import { render, staticRenderFns } from "./report-content.vue?vue&type=template&id=0ba735be&scoped=true"
import script from "./report-content.vue?vue&type=script&lang=js"
export * from "./report-content.vue?vue&type=script&lang=js"
import style0 from "./report-content.vue?vue&type=style&index=0&id=0ba735be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba735be",
  null
  
)

export default component.exports